import { render, staticRenderFns } from "./Trees.vue?vue&type=template&id=2672dcac&scoped=true&"
var script = {}
import style0 from "./Trees.vue?vue&type=style&index=0&id=2672dcac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2672dcac",
  null
  
)

export default component.exports